import {
  Container
} from "./chunk-GQ3RJ3UX.mjs";
import {
  SearchField
} from "./chunk-OJCD46GK.mjs";

// src/GlobalSearchBar.tsx
import { useTheme } from "@mui/material/styles/index.js";
import Box from "@mui/material/Box/index.js";
import Typography from "@mui/material/Typography/index.js";
import SearchIcon from "@mui/icons-material/esm/Search.js";
import { useTranslation } from "react-i18next";
import { jsx, jsxs } from "react/jsx-runtime";
var GlobalSearchBar = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(
    Box,
    {
      component: "section",
      sx: {
        py: { xs: 2, md: 3 },
        bgcolor: "background.paper",
        borderBottom: 1,
        borderColor: "divider"
      },
      children: /* @__PURE__ */ jsx(Container, { children: /* @__PURE__ */ jsxs(
        Box,
        {
          sx: {
            maxWidth: 720,
            mx: "auto",
            textAlign: "center"
          },
          children: [
            /* @__PURE__ */ jsx(Typography, { variant: "h5", component: "h2", gutterBottom: true, fontWeight: 600, children: t("searchBoxHero.title") }),
            /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 2 }, children: t("searchBoxHero.subtext_1") }),
            /* @__PURE__ */ jsx(
              SearchField,
              {
                label: /* @__PURE__ */ jsxs(Typography, { sx: { display: "flex", alignItems: "center" }, children: [
                  /* @__PURE__ */ jsx(SearchIcon, { sx: { marginRight: "0.5rem" } }),
                  t("searchBoxHero.searchBoxLabel")
                ] }),
                sx: {
                  width: "100%",
                  textAlign: "left",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 1,
                    backgroundColor: theme.palette.background.paper
                  }
                }
              }
            )
          ]
        }
      ) })
    }
  );
};
export {
  GlobalSearchBar
};
